import { apiClient } from '../../client'
import { useGenericRequestHandler } from '../../handlers'

const route = `v1/i/deviceSignOut`

export function deviceSignOut() {
  return apiClient.post(route)
}

export function useDeviceSignOutMutation() {
  return useGenericRequestHandler({
    route,
    method: 'POST'
  })
}
